import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import App from './App.tsx';
// import TritonApp from './triton-one/App.tsx';
// import { DataContextProvider as TritonDataContextProvider } from './triton-one/contexts/index.tsx';

import { DataContextProvider } from './contexts/index.tsx';

import { NotFoundPage } from './pages/not-found';
import { ErrorPage } from './pages/error';
import { Toast } from './components/Toast/index.tsx';
import { PostHogProviderWrapper } from './components/PosthogProvider/index.tsx';
import { HashUsedPage } from './pages/hash-used/index.ts';
import { EmailPage } from './pages/email/index.ts';
import { RecordPage } from './pages/record/index.ts';

import './sentry';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProviderWrapper>
      <BrowserRouter>
        <Routes>
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/hash-used" element={<HashUsedPage />} />
          <Route path="/email" element={<EmailPage />} />
          <Route path="/record" element={<RecordPage />} />
          {/* <Route
            path="/triton-one/:hash/:preview?"
            element={
              <TritonDataContextProvider>
                <TritonApp />
              </TritonDataContextProvider>
            }
          /> */}
          <Route
            path="/:hash"
            element={
              <DataContextProvider>
                <App />
              </DataContextProvider>
            }
          />
          <Route
            path="/:version/:hash"
            element={
              <DataContextProvider>
                <App />
              </DataContextProvider>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toast />
      </BrowserRouter>
    </PostHogProviderWrapper>
  </React.StrictMode>
);
